<template>
  <div>
    <section class="content-section no-break">
      <h1>Done & Upcoming Projects</h1>
      <h2>MITREX & CLADIFY</h2>

      <img
        class="exception" 
        src="http://api.camas.app/static/images/images/image__29466c5cace303dcda54b383152b687f.png"
      />
    </section>
    <section class="content-section">
      <h1>Done & Upcoming Projects</h1>
      <h2>MITREX & CLADIFY</h2>

      <img
        class="exception" 
        src="https://api.camas.app/static/images/images/image__4a7aa60e91efbb2ce8d81f686726a90b.png"
      />
    </section>
  </div>
</template>

<script>
export default {
  props: {
    rfq: {
      type: Object
    }
  }
}
</script>

<style lang="scss" scoped>
.more-projects {
  font-size: 0.8em;
  text-align: center;
  a {
    font-weight: bold;
  } 
}

.no-break {
  page-break-after: avoid !important;
}
</style>
